const Constants = {
    USER_ROLES : {
        VENDOR : 'vendor',
        EMPLOYEE: 'employee'
    },
    VALIDATION_PATTERNS : {
        EMAIL : /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
    },
    LOCAL_STORAGE : {
        USER : 'user',
        ACCESS_TOKEN : 'accessToken',
        USER_BALANCE : 'balance',
        CART : 'cart',
        CART_UPDATED_TIME : 'cartUpdatedTime',
        USERS_EVENT: 'event',
        EVENT: 'eventDetails',
        LOCATION_DETAILS: 'locationDetails',
        SELECTED_LOCATION: 'selectedLocation'
    },
    SOCKET : {
        CONNECT: 'connect',
        EMIT : 'emit',
        EVENTS : {
            VENDOR : 'vendor',
            VENDOR_TRANSACTIONS: 'vendorTransactions'
        }
    },
    
    TRANSACTION_TYPE : {
        DEBIT : 'debit',
        CREDIT : 'credit'
    },
    SHOP : {
        MAX_QUANTITY_PER_ITEM : 50,
        BALANCE_ALERT : {
            EXPIRY_WARNING_DATE : 25
        },
        DEFAULT_LOCATION: {
            ID: -1
        }
    },
    CART : {
        ELLIPSIS: {
            LIMIT: 13,
            CONTENT: "..."
        }
    },
    TYPE: {
        NUMBER: 'number',
        CDW: 'CDW'
    },
    HANDLER: {
        MOUSEDOWN: 'mousedown'
    },
    STYLES: {
        HIDDEN: 'hidden',
        AUTO: 'auto'
    },
    COLORS: {
        WHITE: "#fff"
    }
    
}

export default Constants;